module.exports = __webpack_public_path__ + "static/media/kirke.7635bf63.png";